/**
 * FGA Manager version constant.
 *
 * This value is replaced at bundle-time by esbuild's `define` option
 * (see scripts/bundle-web-component.mjs). During library development
 * (ng build), it falls back to the placeholder so unit tests still pass.
 *
 * @example
 * ```typescript
 * import { FGA_MANAGER_VERSION } from './version';
 * console.log(FGA_MANAGER_VERSION); // '1.2.3'
 * ```
 */

// The string '0.0.0-dev' is a sentinel that tells you the bundle step
// did not run.  Production bundles will contain the real semver.
declare const __FGA_MANAGER_VERSION__: string;

export const FGA_MANAGER_VERSION: string =
  typeof __FGA_MANAGER_VERSION__ !== 'undefined'
    ? __FGA_MANAGER_VERSION__
    : '0.0.0-dev';
